<template>
	<div class="animated fadeIn bg-white">
		<div class="container">
			<div class="row">
				<div class="col-md-6 col-lg-6 col-sm-12 mt-2" v-if="data.banners.length>0">
					<swiper :options="swiperOption">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="slide in data.banners">
								<img class="img-fluid mx-auto d-block" :src="slide.url">
							</div>
						</div>
					</swiper>
				</div>
				<div class="col-md-6 col-lg-6 col-sm-12 mt-2" v-if="data.video.ytID&&data.video.ytID!=''">
					<div class="container">
						<div class="embed-responsive embed-responsive-16by9">
							<iframe class="embed-responsive-item" :src="'https://www.youtube.com/embed/'+data.video.ytID" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 col-xs-12 col-sm-12">
					<vue-bootstrap4-table :rows="table.wallsman.rows" :columns="table.wallsman.columns" @refresh-data="sendAPI"
					:config="table.wallsman.config">
					<template slot="view" slot-scope="props">
						<button @click="viewByID(props.cell_value)" type="button" class="btn btn-info"><i class="far fa-eye"></i></button>
					</template>
					<template slot="approve" slot-scope="props">
						<button v-if="props.cell_value!=''&&props.cell_value!=null" @click="openModalWM(props.cell_value,'approve')" type="button" class="btn btn-primary"><i class="far fa-clipboard-check"></i></button>
						<span v-else>-</span>
					</template>
					<template slot="reject" slot-scope="props">
						<button v-if="props.cell_value!=''&&props.cell_value!=null" @click="openModalWM(props.cell_value,'reject')" type="button" class="btn btn-danger"><i class="far fa-vote-nay"></i></button>
						<span v-else>-</span>
					</template>
				</vue-bootstrap4-table>
			</div>
			<div class="col-md-12 col-xs-12 col-sm-12">
				<vue-bootstrap4-table :rows="table.top_sales.rows" :columns="table.top_sales.columns" @refresh-data="sendAPI"
				:config="table.top_sales.config">
				<template slot="approve" slot-scope="props">
					<button v-if="props.cell_value!=''&&props.cell_value!=null" @click="openModalRequest(props.cell_value,'approve')" type="button" class="btn btn-primary"><i class="far fa-clipboard-check"></i></button>
					<span v-else>-</span>
				</template>
				<template slot="reject" slot-scope="props">
					<button v-if="props.cell_value!=''&&props.cell_value!=null" @click="openModalRequest(props.cell_value,'reject')" type="button" class="btn btn-danger"><i class="far fa-vote-nay"></i></button>
					<span v-else>-</span>
				</template>
			</vue-bootstrap4-table>
		</div>
		<div class="col-md-12 col-xs-12 col-sm-12">
			<vue-bootstrap4-table :rows="table.top_skus.rows" :columns="table.top_skus.columns" @refresh-data="sendAPI"
			:config="table.top_skus.config">
			<template slot="approve" slot-scope="props">
				<button v-if="props.cell_value!=''&&props.cell_value!=null" @click="openModalRequest(props.cell_value,'approve')" type="button" class="btn btn-primary"><i class="far fa-clipboard-check"></i></button>
				<span v-else>-</span>
			</template>
			<template slot="reject" slot-scope="props">
				<button v-if="props.cell_value!=''&&props.cell_value!=null" @click="openModalRequest(props.cell_value,'reject')" type="button" class="btn btn-danger"><i class="far fa-vote-nay"></i></button>
				<span v-else>-</span>
			</template>
		</vue-bootstrap4-table>
	</div>
</div>
</div>
<Loading :percent="load.percent" :active="load.active"></Loading>
</div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import JWT from '../utils/JWT.js';
import { getIdFromURL } from 'vue-youtube-embed'
export default {
	components: {
		'VueBootstrap4Table': () => import('vue-bootstrap4-table'),
		'Loading': () => import('../utils/Loading.vue'),swiper,swiperSlide
	},
	data() {
		return {
			swiperOption:{
				autoplay: 3000,
				speed: 1000
			},
			alert: {
				message: ''
			},
			load: {
				task: 0,
				count: 0,
				percent: 0,
				active: false
			},
			data: {
				video:{
					ytID:'',
					details: '',
					name:''
				},
				banners:{}
			},
			table: {
				wallsman: {
					rows: [],
					config: {
						per_page: 5,
						per_page_options: [5, 10, 15, 30, 35, 40, 45, 50, 100],
						global_search: {
							placeholder: "ค้นหา...",
						},
						card_title: 'ข้อมูลของวอลล์แมน/วอลล์เลดี้ที่รอการตรวจสอบ'
					},
					columns: [{
						label: "ID",
						name: "id",
						sort: true,
						initial_sort: true,
						initial_sort_order: "desc"
					}, {
						label: "รหัสมินิ",
						name: "mini_code",
						sort: true
					}, {
						label: "ชื่อมินิ",
						name: "mini_name",
						sort: true
					},{
						label: "ชื่อ-นามสกุล",
						name: "full_name",
						sort: true
					},{
						label: "เบอร์โทรตืดต่อ",
						name: "contact_number",
						sort: true
					},{
						label: "หมายเลขบัตรประชาชน",
						name: "citizen_id",
						sort: true
					},{
						label: "รหัสบาร์โค้ดรถ",
						name: "bike_barcode",
						sort: true
					}, {
						label: "ทะเบียนรถ",
						name: "plate_no",
						sort: true
					},{
						label: "วันที่ยืนคำร้อง",
						name: "created_at",
						sort: true
					}]
				},
				top_sales:{
					rows: [],
					config: {
						per_page: 5,
						per_page_options: [5, 10, 15, 30, 35, 40, 45, 50, 100],
						global_search: {
							placeholder: "ค้นหา...",
						},
						card_title: 'กระดานม้าแข่ง Top Sales'
					},
					columns: [{
						label: "rank",
						name: "อันดับ",
						sort: true,
						initial_sort: true,
						initial_sort_order: "asc"
					}, {
						label: "Mini Code",
						name: "mini_code",
						sort: true
					}, {
						label: "Mini Name",
						name: "mini_name",
						sort: true
					},{
						label: "WM Code",
						name: "wm_code",
						sort: true
					},{
						label: "Full Name",
						name: "full_name",
						sort: true
					}, {
						label: "ยอดรวม",
						name: "total",
						sort: true
					}]
				},
				top_skus:{
					rows: [],
					config: {
						per_page: 5,
						per_page_options: [5, 10, 15, 30, 35, 40, 45, 50, 100],
						global_search: {
							placeholder: "ค้นหา...",
						},
						card_title: 'ยอดขายล่าสุด Top 20 SKU'
					},
					columns: [{
						label: "rank",
						name: "อันดับ",
						sort: true,
						initial_sort: true,
						initial_sort_order: "asc"
					}, {
						label: "Product Code",
						name: "product_code",
						sort: true
					}, {
						label: "ชื่อผลิตภัณฑ์",
						name: "name",
						sort: true
					},{
						label: "ยอดรวม",
						name: "total",
						sort: true
					}]
				}
			}
		}
	},
	async mounted() {
		this.sendAPI();		
	},
	methods: {
		resetLoading(task) {
			this.load.count = 0
			this.load.task = task
			this.load.percent = 0
			this.load.active = true
		},
		async sendAPI() {
			try {
				await this.resetLoading(1)
				let value=null,rank=0, data={top_skus:[],top_sales:[]},banner=null,banners=[]
				const res = ((await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/dashboard')).body)
				if(res['video'].link&&res['video'].link!=''){
					this.data.video = {
						ytID: await getIdFromURL(res['video'].link),
						details: res['video'].details,
						name: res['video'].name
					};
				}
				for(banner of res['banners']){
					banners.push({id:banner.id,url: process.env.VUE_APP_CDN+banner.path})
				}
				this.data.banners = banners
				await res['top_skus'].sort((a,b) => a['total'] - b['total']);
				for(value of res['top_skus']){
					rank=rank+1;
					data['top_skus'].push({rank:rank,product_code:value.product_code,name:value.name,total:value.total});
				}
				rank=0;
				await res['top_sales'].sort((a,b) => a['total'] - b['total']);
				for(value of res['top_sales']){
					rank=rank+1;
					data['top_sales'].push({rank:rank,mini_code:value.mini_code,mini_name:value.mini_name,wm_code:value.wm_code,full_name:value.full_name,total:value.total});
				}
				this.table.top_sales.config.card_title='กระดานม้าแข่ง Top Sales (ย้อนหลังสามเดือน '+res['date'].start+' ถึง '+res['date'].end+')'
				this.table.top_skus.config.card_title='ยอดขายล่าสุด Top 20 SKU (ย้อนหลังสามเดือน '+res['date'].start+' ถึง '+res['date'].end+')'
				this.table.top_skus.rows = data['top_skus'];
				this.table.top_sales.rows = data['top_sales'];
				this.table.wallsman.rows = res['wallsman'];
				this.load.active = false
			} catch (error) {
				this.load.active = false
				if (error.body) {
					if (error.body.alert) {
						this.alert.message = error.body.alert
					} else {
						this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
					}
				} else {
					this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
				}
				this.$dialogs.alert(this.alert.message,{title: 'เกิดข้อผิดพลาดในการดึงข้อมูล'})
			}
		}
	}
}
</script>